import CardsViewProvider from "./CardsView.provider"

export default {
    Provider: CardsViewProvider,
}
